import React from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import UserLogin from './UserLogin';
import TreeContainer from './tree/TreeContainer';
import Admin from './Pages/Admin';
import AcceptRejectStage from './Pages/AcceptRejectStage';
import DemoSite from './Pages/DemoSite';
import Feedback from './Pages/Feedback';
import LiveSite from './Pages/LiveSite';
import login from './login/login';
import { withAdalLoginApi } from '../adal/adalConfig';
import Loader from './loader';
import PublishedResultsContainer from './publishedResults/publishedResultsContainer';

export default class Routes extends React.Component {
    componentWillMount() {
        this.setState({
            homePage: withAdalLoginApi(UserLogin, () => <Loader />),
            acceptrejectstage: withAdalLoginApi(AcceptRejectStage, () => <Loader />),
            demosite: withAdalLoginApi(DemoSite, () => <Loader />),
            feedback: withAdalLoginApi(Feedback, () => <Loader />),
            livesite: withAdalLoginApi(LiveSite, () => <Loader />),
            tree: withAdalLoginApi(TreeContainer, () => <Loader />),
            admin: withAdalLoginApi(Admin, () => <Loader />),
            publishResults: withAdalLoginApi(PublishedResultsContainer, () => <Loader />)
        });
    }
    render() {
        const { homePage, acceptrejectstage, publishResults,
            demosite, feedback, livesite, tree, admin } = this.state;
        return (
            <Router>
                <div>
                    <Route exact path="/" component={login} />
                    <Route exact path="/home" component={homePage} />
                    <Route path="/acceptrejectstage" component={acceptrejectstage} />
                    <Route path="/demosite" component={demosite} />
                    <Route path="/feedback" component={feedback} />
                    <Route path="/livesite" component={livesite} />
                    <Route path="/tree" component={tree} />
                    <Route path="/admin" component={admin} />
                    <Route path="/adminPublish" component={admin} />
                    <Route path="/adminController" component={admin} />
                    <Route path="/publishResults/:treeId" component={publishResults} />
                </div>
            </Router>
        );
    }
}
;



// WEBPACK FOOTER //
// ./src/components/Routes.js